import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import RELEASE from '@mlc/release';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.html',
})
export class Footer {
  build = `v${RELEASE.version}-${RELEASE.build}`;
}
